import React from "react";
import Contact from "../../components/Contact/Contact";

const ContactPage = () => {
  return (
    <div className="pb-5" style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <Contact />
    </div>
  );
};

export default ContactPage;
